module.exports = __webpack_public_path__ + "img/tu02.a387bfce.jpg";